export default "__VITE_ASSET__c364006a__"